import {
  makeStyles,
  Theme,
  createStyles,
  Grid,
  Paper,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import DataService from "../../Service";
import CustomSelect from "../../Components/CustomSelect";

// import { Post_API } from "../../Service/service";
import { api_url } from "../../constants";
import { Link, useHistory } from "react-router-dom";
import CustomInput from "../../Components/CustomInput";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AuthClient from "../../Service/auth_services";
import logo from "../../Images/aimio-logo.png";
import CircularIndeterminate from "../../Components/Loader";
import { showSnackbar } from "../../Components/Snackbar/SnackbarActions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) =>
  createStyles({
    formControl: {
      width: "100%",
    },
    textSecondary: {
      color: theme.palette.secondary.main,
    },
  })
);
const Register = () => {
  const classes = useStyles();
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const dataObject = {
    role: "",
  };
  const [role, setRole] = useState({});
  const dispatch = useDispatch();
  const [orgName, setOrgName] = useState("");
  const [roles, setRoles] = useState([]);
  const [submitClickFlag, setSubmitClickFlag] =useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  // const roleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  //   setRole(event.target.value as string)
  // }
  console.log('Object.values(role).length :>> ', Object.values(role).length, role);
  const register = () => {
    setLoading(true);
    if (username != "" && email != "" && orgName != "" && role != "") {
      setSubmitClickFlag(false);
      AuthClient.signUp({
        name: username,
        email: email,
        role_id: role,
        organisation_name: orgName,
      })
        .then((response) => {
          setLoading(false);
          if (response.message) {
            dispatch(showSnackbar("error", [response.message]));
          } else {
            registerSuccess(response);
            dispatch(showSnackbar("success", ["User register successfully"]));
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      setSubmitClickFlag(true);
      setLoading(false);
    }
  };
  const registerSuccess = (response) => {
    history.push("/auth/login");
  };
  const setInputState = (inputStateValue, inputId) => {
    inputId === "username" && setUserName(inputStateValue);
    inputId === "email" && setEmail(inputStateValue);
    inputId === "orgName" && setOrgName(inputStateValue);
    // inputId === "role" && setRole(inputStateValue)
  };
  useEffect(() => {
    fetchRoles();
  }, []);
  const fetchRoles = () => {
    DataService.getDirectData(`/role_dropdown`)
      .then((res) => {
        if (res?.success) {
          setRoles(res["role_type"]);
          console.log("res.role_dropdown :>> ", res);
        }
      })
      .catch((err) => {});
  };

  const onChangeItem = (selectedItemValue) => {
    console.log(selectedItemValue);

    setRole({ ...role, [selectedItemValue.id]: selectedItemValue.value });
  };
  const handleDropDownValue = (event) => {
    const { name, value } = event?.target;
    console.log("object :>> ", event.target.value);
    // setRole(({ ...role, [name]: value }));
  };
  const sortByArray = [
    {
      id: 1,
      value: "admin",
    },
    {
      id: 2,
      value: "finance_admin",
    },
    {
      id: 3,
      value: "partner",
    },
    {
      id: 4,
      value: "employee",
    },
  ];
  return (
    <form
      noValidate
      autoComplete="on"
      onKeyPress={(e) => {
        e.key === "Enter" && register();
      }}
    >
      <Grid container direction="row" justify="center">
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <img src={logo} alt="Acuity" style={{ width: 150 }} />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 30 }}>
          <CustomInput
            id="username"
            placeholder="Username"
            parentcall={setInputState}
            helperText={
              submitClickFlag && username == "" ? "Please enter username." : ""
            }
            error={submitClickFlag && username == "" ? true : false}
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 30 }}>
          <CustomInput
            id="email"
            placeholder="Email"
            parentcall={setInputState}
            helperText={
              submitClickFlag && email == "" ? "Please enter email." : ""
            }
            error={submitClickFlag && email == "" ? true : false}
          />
        </Grid>
        {/* <Grid item xs={12} style={{ marginTop: 30 }}> */}
        <Grid item xs={12} style={{ marginTop: 30 }}>
          <CustomInput
            id="orgName"
            placeholder="Organization Name"
            parentcall={setInputState}
            helperText={
              submitClickFlag && orgName == ""
                ? "Please enter organization name."
                : ""
            }
            error={submitClickFlag && orgName == "" ? true : false}
          />
        </Grid>
        {/* {" "}
        </Grid> */}

        <Grid item xs={12} style={{ marginTop: 30 }}>
          {/* <CustomInput
            id="role"
            placeholder="Role"
            parentcall={setInputState}
            helperText={
              submitClickFlag && role == ""
                ? "Please enter role."
                : ""
            }
            error={submitClickFlag && role == "" ? true : false}
          /> */}
       

          <Select
            id="role"
            name="role"
            placeholder="Role"
            onChange={(e) => setRole(e.target.value)}
            helperText={
              submitClickFlag && role == ""
                ? "Please enter role."
                : ""
            }
            error={submitClickFlag && role == "" ? true : false}
            // onChange={setQuestionChangeState}
            style={{ width: "100%" }}
            inputProps={{
              id: "outlined-age-native-simple",
            }}
          >
           {roles &&
              roles.map((base) => (
                <MenuItem key={base.id} value={base.id}>
                  {base.value}
                </MenuItem>
              ))}
          </Select>
        </Grid>

        <Grid item xs={12} style={{ marginTop: 15 }}>
          <Typography variant="subtitle1" style={{ textAlign: "left" }}>
            <Link
              className={classes.textSecondary}
              to={{
                pathname: "/auth/login",
                state: { subPage: "login" },
              }}
            >
              Login to existing account{" "}
            </Link>
            <ArrowForwardIcon
              style={{ fontSize: 14, verticalAlign: "middle" }}
              className={classes.textSecondary}
            />
          </Typography>
        </Grid>
        <Grid
          item
          xs={3}
          justify="center"
          alignContent="center"
          style={{ marginTop: 20, textAlign: "center" }}
        >
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            onClick={register}
          >
            {" "}
            <span style={{ textTransform: "none" }}> Register </span>
          </Button>
        </Grid>
      </Grid>
      {loading && <CircularIndeterminate />}
    </form>
  );
};

export default Register;
